/**
 * The sticky JotBill page header's MEASURED height, published as a CSS
 * variable by JotBillCenterShell (GDN-3214). Sticky children inside any tab
 * must offset below the header, and a hand-written pixel constant regresses
 * silently the day someone edits the header — so the shell observes its own
 * header and the number can never drift from reality. Consume via
 * `jotBillStickyTop`, never the raw var name.
 */
export const JOTBILL_HEADER_HEIGHT_VAR = '--jotbill-header-height';

/** Fallback before the first measurement lands (and for non-shell contexts
 *  like Storybook): the header's historical design height. */
export const JOTBILL_HEADER_HEIGHT_FALLBACK_PX = 160;

/** `top` for a sticky element inside a JotBill tab: below the page header,
 *  plus a gap. */
export function jotBillStickyTop(gapPx: number): string {
  return `calc(var(${JOTBILL_HEADER_HEIGHT_VAR}, ${JOTBILL_HEADER_HEIGHT_FALLBACK_PX}px) + ${gapPx}px)`;
}

/**
 * Rounding for the measurement itself: FLOOR, never round-to-nearest.
 * The header's true height is often fractional (tabs + typography at
 * non-integer device scales), and a sticky child pinned flush below it
 * must never land BELOW the header's true bottom edge — rounding 160.5 up
 * to 161 opens a sub-pixel slit where scrolled rows bleed through as a
 * 1px line. Flooring instead tucks the child up to 1px UNDER the opaque
 * header (which paints above it), which is invisible.
 */
export function jotBillHeaderHeightPx(measuredPx: number): number {
  return Math.floor(measuredPx);
}
